// 세션 리플레이 SDK 연동 (Carrot 자체 모니터링). OpenReplay 와 병행 가동한다.
// setUserID 호출 지점(ComHeader·home·signUpOk·login)에서 recorder 를 참조할 수 있도록
// 얇은 싱글톤 모듈로 보관한다. main.js 에서 tracker.start() 옆에 startSessionReplay() 를 호출한다.
import { ReplayRecorder } from "@carrot/session-replay/core";

// 어드민(replays-admin.carrotsolutions.co.kr)에서 발급받은 X-Replay-Project-Key.
const REPLAY_PROJECT_KEY = "HUY4E45G";

let recorder = null;

// 앱 부트스트랩 시 1회 호출. localhost 는 SDK 내부에서 자동으로 녹화하지 않는다.
export async function startSessionReplay() {
  if (recorder) return;
  recorder = new ReplayRecorder({ projectKey: REPLAY_PROJECT_KEY });
  await recorder.start();
}

// 로그인/사용자 확정 시 호출. 기존 tracker.setUserID(...) 옆에 나란히 둔다.
export function setReplayUserId(userId) {
  recorder?.setUserId(userId);
}
